/**
 * Enable "copy url" and social share tracking
 */

import Toastify from 'toastify-js';

const sharingEventHandler = ( ev: Event ) => {
  //ev.preventDefault();
  const $elem = ev.currentTarget as HTMLElement;

  const { provider, postTitle } = $elem.dataset;

  let gtagEventName = 'social share';
  let gtagEventLabel = provider;

  if ( provider === 'link' ) {
    gtagEventName = 'copy article';
    gtagEventLabel = postTitle;

    // Use the current URL. Should the WP permalink used instead?
    const url = window.location.href;

    navigator.clipboard.writeText( url ).then( () => {
      const toast = Toastify( {
        text: "Enlace copiado al portapapeles.",
        duration: 3000,
        gravity: "bottom", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        onClick: function() {
          if ( toast ) {
            toast.hideToast();
          }
        }
      } );

      toast.showToast();
    }, (err) => {
      console.error('Could not copy text: ', err);
    } );
  }

  // Check if gtag exists
  if ( typeof gtag === 'function' ) {
    const eventDetails = {
      'event_category': 'NTG social',
      'event_label': gtagEventLabel,
      'non_interaction' : false
    }

    gtag( 'event', gtagEventName, eventDetails );
  }
}

export default () => {
  const $elems = document.querySelectorAll( '.share-button' );
  $elems.forEach( $button => $button.addEventListener( 'click', sharingEventHandler ) );
}
